export const emptyList = [
  {
    mode: "home",
    main: "Empty Library",
    sub: "Click the import button to add books",
  },
  {
    mode: "favorite",
    main: "No Favorite Books",
    sub: "Right click on any book and Click Add to Favorite to add it to your favorite books",
  },
  {
    mode: "bookmark",
    main: "Empty Bookmark",
    sub: "Move your mouse on the top edge of the reader",
  },
  {
    mode: "note",
    main: "Empty Note",
    sub: "Select any text and click the Note button on the popup menu",
  },
  {
    mode: "digest",
    main: "Empty Highlight",
    sub: "Select any text and click the Highlight button on the popup menu",
  },
  {
    mode: "shelf",
    main: "Empty Shelf",
    sub: "Move your mouse on top of any book, then click the more icon to add the book to the shelf",
  },

  {
    mode: "trash",
    main: "Empty Recycle Bin",
    sub: "The deleted books will show up here",
  },
];
